module.exports = __webpack_public_path__ + "img/portfolio.8982974b.png";